<script setup lang="ts">
	definePageMeta({
		colorMode: 'dark',
		// middleware: [
		// 	'auth',
		// ]
	});

  import { computed } from 'vue';

  </script>

<template>
	<slot />
</template>

<style lang="scss" scoped>
:host {
  background-color: red;
}
</style>
